import { Organization } from '@kaizenplatform/intelligence-entity';
import Goal from './Goal';
import Chart, { IChart } from './Chart';

export interface ILiftReport {
  id: string;
  organization: Organization;
  goal: Goal;
  charts?: Chart[] | null;
  enabled: boolean;
  mainGoal: boolean;
  activityPeriodFrom?: string | null;
  activityPeriodTo?: string | null;
}

class LiftReport {
  public readonly id: string;
  public readonly organization: Organization;
  public readonly goal: Goal;
  public readonly charts?: Chart[] | null;
  public readonly enabled: boolean;
  public readonly mainGoal: boolean;
  public readonly activityPeriodFrom?: string | null;
  public readonly activityPeriodTo?: string | null;

  constructor({
    id,
    organization,
    goal,
    charts,
    enabled,
    mainGoal,
    activityPeriodFrom,
    activityPeriodTo,
  }: {
    id: string;
    organization: Organization;
    goal: Goal;
    charts?: Chart[] | null;
    enabled: boolean;
    mainGoal: boolean;
    activityPeriodFrom?: string | null;
    activityPeriodTo?: string | null;
  }) {
    this.id = id;
    this.organization = organization;
    this.goal = goal;
    this.charts = charts;
    this.enabled = enabled;
    this.mainGoal = mainGoal;
    this.activityPeriodFrom = activityPeriodFrom;
    this.activityPeriodTo = activityPeriodTo;
  }

  public toJSON = () => ({
    id: this.id,
    organization: this.organization,
    goal: this.goal,
    charts: this.charts,
    enabled: this.enabled,
    mainGoal: this.mainGoal,
    activityPeriodFrom: this.activityPeriodFrom,
    activityPeriodTo: this.activityPeriodTo,
  });

  public static fromJSON = (json: ILiftReport): LiftReport => {
    const { id, organization, goal, charts, enabled, mainGoal, activityPeriodFrom, activityPeriodTo } = Object.assign(
      {},
      json,
    );

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof enabled !== 'boolean') throw new Error('.enabled must be a boolean');
    if (typeof mainGoal !== 'boolean') throw new Error('.mainGoal must be a boolean');
    if (!Array.isArray(charts) && charts !== undefined && charts !== null) throw new Error('.charts must be a array');
    if (typeof activityPeriodFrom !== 'string' && activityPeriodFrom !== null && activityPeriodFrom !== undefined)
      throw new Error('.activityPeriodFrom must be a string');
    if (typeof activityPeriodTo !== 'string' && activityPeriodTo !== null && activityPeriodTo !== undefined)
      throw new Error('.activityPeriodTo must be a string');

    const _organization = Organization.fromJSON(organization);
    const _goal = Goal.fromJSON(goal);
    const _chart = charts
      ? charts.map((chart: IChart) => {
          return Chart.fromJSON(chart);
        })
      : null;

    return new LiftReport({
      id,
      organization: _organization,
      goal: _goal,
      charts: _chart,
      enabled,
      mainGoal,
      activityPeriodFrom,
      activityPeriodTo,
    });
  };
}

export default LiftReport;
